
<iframe
  autosize
  [ngClass]="{'ed--extended': context.config.template_data.qualified_leads}"
  class="ed-contactform-frame"
  [src]="context.links.contact_form | safe"
></iframe>
